export default "__VITE_ASSET__BtQ9sZAn__"